import { useMemo } from "react";
import { IAirport } from "../globals/interfaces";
import { useStaticData } from "../utils";

export default function useAirportCodes(allData?: boolean) {
    // Determine endpoint based on allData parameter
    const endpoint = allData ? '/airport' : '/airport/codes';
    
    // Use the static data hook
    const { data, isLoading, error } = useStaticData(endpoint);
    
    // Process the data to create both array and map
    const { airportCodes, airportCodesMap } = useMemo(() => {
        if (!data) {
            return {
                airportCodes: [] as Array<IAirport>,
                airportCodesMap: {} as Record<string, string>
            };
        }
        
        const map: Record<string, string> = {};
        for (const { code, name } of data) {
            map[code] = name;
        }
        
        return {
            airportCodes: data,
            airportCodesMap: map
        };
    }, [data]);

    return {
        airportCodes,
        airportCodesMap,
        isLoading,
        error
    };
}